import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { API } from "../api";

const isAppHost = (h) =>
  h === "localhost" || h.startsWith("127.") || h.includes("emergent") || h.includes("uaicard");

// Si se entra por el dominio propio de un cliente, abre directo su portafolio.
const HostGate = ({ children }) => {
  const host = window.location.hostname.toLowerCase();
  const [checking, setChecking] = useState(!isAppHost(host));
  const navigate = useNavigate();

  useEffect(() => {
    if (!checking) return;
    fetch(`${API}/portfolios/by-domain/${encodeURIComponent(host)}`)
      .then((r) => (r.ok ? r.json() : null))
      .then(async (d) => {
        if (d) return navigate(`/${d.domain}/${d.slug}`, { replace: true });
        const m = await fetch(`${API}/market/by-domain/${encodeURIComponent(host)}`).then((r) => (r.ok ? r.json() : null));
        if (m) return navigate(`/m/${m.slug}`, { replace: true });
        const c = await fetch(`${API}/crm/by-domain/${encodeURIComponent(host)}`).then((r) => (r.ok ? r.json() : null));
        if (c) navigate(`/c/${c.slug}`, { replace: true });
        else setChecking(false);
      })
      .catch(() => setChecking(false));
  }, [checking, host, navigate]);

  return checking ? null : children;
};

export default HostGate;
